import script from "./InspecaoSupervisaoEstabelecimentoFinalizacao.vue?vue&type=script&setup=true&lang=js"
export * from "./InspecaoSupervisaoEstabelecimentoFinalizacao.vue?vue&type=script&setup=true&lang=js"

import "./InspecaoSupervisaoEstabelecimentoFinalizacao.vue?vue&type=style&index=0&id=cf108afc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf108afc"]])

export default __exports__